import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";

/**
 * ConsoleLogger singleton.
 */
var ConsoleLogger = /*#__PURE__*/function () {
  function ConsoleLogger(levels) {
    _classCallCheck(this, ConsoleLogger);

    this.levels = levels;
  }

  _createClass(ConsoleLogger, [{
    key: "log",
    value: function log() {
      var _console;

      // eslint-disable-next-line no-console
      if (this.levels.verbose) (_console = console).log.apply(_console, arguments);
    }
  }, {
    key: "info",
    value: function info() {
      var _console2;

      if (this.levels.info) (_console2 = console).info.apply(_console2, arguments);
    }
  }, {
    key: "debug",
    value: function debug() {
      var _console3;

      if (this.levels.debug) (_console3 = console).debug.apply(_console3, arguments);
    }
  }, {
    key: "warn",
    value: function warn() {
      var _console4;

      if (this.levels.warnings) (_console4 = console).warn.apply(_console4, arguments);
    }
  }, {
    key: "error",
    value: function error() {
      var _console5;

      if (this.levels.errors) (_console5 = console).error.apply(_console5, arguments);
    }
  }], [{
    key: "new",
    value: function _new() {
      var levels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        verbose: false,
        info: false,
        debug: false,
        warnings: true,
        errors: true
      };
      if (!this.instance) this.instance = new ConsoleLogger(levels);else this.instance.levels = levels;
      return this.instance;
    }
  }]);

  return ConsoleLogger;
}();

export { ConsoleLogger as default };